import { handlePhotosUploadFactory } from '@app/utils/photos'

import { loaderStatus } from '../constants'
import { BaseLoader } from '../loaders/BaseLoader'

import type { UploadFilesFn } from '@app/types'

export class PhotosUploader extends BaseLoader {
  percent: number = 0

  private readonly photos: File[]
  private readonly upload: UploadFilesFn

  private loadedPhotos: number = 0

  constructor (taskId: string | number, photos: File[]) {
    super()

    this.photos = photos
    this.upload = handlePhotosUploadFactory({
      id: taskId,
      onPhotoUploaded: this.handlePhotoUploaded
    })
  }

  start (): void {
    if (this.status === loaderStatus.LOADING) return

    this.handleLoading()

    this.upload(this.photos)
      .then(this.handleSuccess)
      .catch(error => {
        this.handleError(error)
      })
      .finally(() => this.handleComplete?.())
  }

  // TODO: подумать над реализацией отмены загрузки позже
  cancel (): void {
    // if (this.status !== loaderStatus.LOADING) return

    throw new Error('This method is not yet implemented!')

    // this.handleCanceled()
  }

  private readonly handlePhotoUploaded = (): void => {
    this.loadedPhotos += 1
    this.percent = (this.loadedPhotos / this.photos.length) * 100
    this.handleProgress?.()
  }
}
